const validatePageModalPath = (path: string) => {
  return /[^\w-]+/g.test(path);
};

export default validatePageModalPath;
